export default class PositionComponentMode {
  static UNSET = new PositionComponentMode('UNSET')
  static POSITION = new PositionComponentMode('POSITION')
  static ROTATION = new PositionComponentMode('ROTATION')

  constructor(name) {
    this.name = name
  }
}
